<p-toast></p-toast>
<div class="dropdown-content">
    <div class="p-fluid p-formgrid grid upper-filter-card">
        <div class="field col-12 md:col-4">
            <label htmlFor="selectOutletMaster">{{'Role'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="userRoleList" [(ngModel)]="selectedUserRole"
                    (onChange)="onSelectUserRoleList()" appendTo="body" placeholder="{{ 'Select User Role'| translate }}"
                    optionLabel="name"></p-dropdown>
            </div>
        </div>
        <div class="field col-12 md:col-4">
            <label htmlFor="">{{'User'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="userIdList" [(ngModel)]="selectedUserId"
                    (onChange)="onSelectUserIdList()" appendTo="body" placeholder="{{ 'Select User Id'| translate }}"
                    optionLabel="name"></p-dropdown>
            </div>
        </div>
        <div class="field col-12 md:col-4">
            <label htmlFor="">{{'Action'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="userActionList" [(ngModel)]="selectedUserAction"
                    (onChange)="onSelectUserActionList()" appendTo="body" placeholder="{{ 'Select User Action'| translate }}"
                    optionLabel="name"></p-dropdown>
            </div>
        </div>
    </div>
</div>
<div *ngIf="rankingReportWithFilteredValTable.length > 0" class="card dashboardTable">
    <div class="header-tab">
        <p>Ranking Criteria: 10 marks will be awarded for within target days for each application and deduction of 0.5 marks per day beyond target days</p>
    </div>
    <p-table #rankingReport [value]="rankingReportWithFilteredValTable" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'Action_Type',
            'UserRole',
            'UserID',
            'User_detail',
            'Nos_of_action',
            'Max_rank',
            'Obtained_Rank_with_Ne',
            'Obtained_Rank_with_Ve',
            'Per_Obtained_Rank_with_Ne',
            'Per_Obtained_Rank_with_Ve',
            'Ranking_Ne',
            'Ranking_Ve'
            ]" responsiveLayout="scroll" [rowHover]="true"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end" [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ 'Ranking Report' | translate}}</h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-12 md:col-2 d-flex justify-content-center">
                    <button *ngIf="rankingReportWithFilteredValTable.length > 0" (click)="menu.toggle($event)" pButton pRipple label=""
                        icon="pi pi-download" class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="rankingReportExport"></p-menu>
                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="dataForFilterDropdown" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedFilterVal"
                        placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-6 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="rankingReport.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'Role' | translate}}</th>
                <th>{{ 'User ID' | translate}}</th>
                <th>{{ 'Action' | translate}}</th>
                <th>{{ 'User Detail' | translate}}</th>
                <th>{{ 'No.s Of App' | translate}}</th>
                <th>{{ 'Max Score' | translate}}</th>
                <!-- <th>{{ 'Rank with NE' | translate}}</th> -->
                <th>{{ 'Obtained Score' | translate}}</th>
                <!-- <th>{{ 'Per Obtained Rank with NE' | translate}}</th> -->
                <th>{{ 'Obtained Percentage' | translate}}</th>
                <!-- <th>{{ 'Ranking NE' | translate}}</th> -->
                <th>{{ 'Rating' | translate}}</th>
                <th style="width:15%">{{ 'Star' | translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-ri="rowIndex">
            <tr class="body-section" (click)="onSelectRow(item)" [ngStyle]="{'background-color': getColorForRanking(item.Rating_Start)}">
                <td>{{item.UserRole}}</td>
                <td>{{item.UserID}}</td>
                <td>{{item.Action_Type}}</td>
                <td>{{item.User_detail}}</td>
                <td>{{item.Nos_of_action}}</td>
                <td>{{item.Max_rank}}</td>
                <!-- <td>{{item.Obtained_Rank_with_Ne}}</td> -->
                <td>{{item.Obtained_Rank_with_Ve}}</td>
                <!-- <td>{{item.Per_Obtained_Rank_with_Ne}}</td> -->
                <td>{{item.Per_Obtained_Rank_with_Ve}}</td>
                <td>{{item.Ranking_Ve}}</td>
                <td><p-rating [(ngModel)]="item.Rating_Start" [readonly]="true" [cancel]="false"></p-rating></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr [ngStyle]="{'background-color': 'rgb(240, 205, 205)'}">
                <td colspan="8">No Data found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div #targetTable *ngIf="rankingReportDrillDownData.length > 0" class="card dashboardTable">
    <p-table #rankingDrillDownReport [value]="rankingReportDrillDownData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'Action_Type',
            'UserRole',
            'User_detail',
            'appid',
            'AssignedDate',
            'Action_Date',
            'Days_Taken',
            'TargetDays',
            'Ne_ranking',
            'Ve_ranking',
            ]" responsiveLayout="scroll" [rowHover]="true"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end" [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ 'Ranking Drill Down Report' | translate}}</h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-12 md:col-2 d-flex justify-content-center">
                    <button *ngIf="rankingReportDrillDownData.length > 0" (click)="menu.toggle($event)" pButton pRipple label=""
                        icon="pi pi-download" class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="rankingReportDrillDownExport"></p-menu>
                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="dataForFilterDropdown" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedFilterVal"
                        placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-6 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="rankingDrillDownReport.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'Role' | translate}}</th>
                <th>{{ 'APP_NO' | translate}}</th>
                <th>{{ 'Action' | translate}}</th>
                <th>{{ 'User Detail' | translate}}</th>
                <th>{{ 'Assigned Date' | translate}}</th>
                <th>{{ 'Action Date' | translate}}</th>
                <th>{{ 'Days Taken' | translate}}</th>
                <th>{{ 'Target Days' | translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-ri="rowIndex">
            <tr class="body-section" (click)="onSelectRow(item)">
                <td>{{item.UserRole}}</td>
                <td>{{item.appid}}</td>
                <td>{{item.Action_Type}}</td>
                <td>{{item.User_detail}}</td>
                <td>{{item.AssignedDate | date:'mediumDate'}}</td>
                <td>{{item.Action_Date | date:'mediumDate'}}</td>
                <td>{{item.Days_Taken}}</td>
                <td>{{item.TargetDays}}</td>

                <!-- <td>{{item.Obtained_Rank_with_Ve}}</td>
                <td>{{item.Per_Obtained_Rank_with_Ve}}</td>
                <td>{{item.Ranking_Ne}}</td>
                <td><p-rating [(ngModel)]="item.Rating_Start" [readonly]="true" [cancel]="false"></p-rating></td> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr [ngStyle]="{'background-color': 'rgb(240, 205, 205)'}">
                <td colspan="8">No Data found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>